import React, { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { StarIcon } from "lucide-react";
const colors = ["#f7c813", "#f08a24", "#ffffff", "#0a8a3f", "#ffd75e"];
export function StarBurst({
  count = 26
}: {
  count?: number;
}) {
  const reduceMotion = useReducedMotion();
  const stars = useMemo(() => Array.from({
    length: count
  }, (_, i) => {
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.6;
    const distance = 150 + Math.random() * 190;
    return {
      id: i,
      x: Math.cos(angle) * distance,
      y: Math.sin(angle) * distance,
      size: 14 + Math.random() * 18,
      rotate: (Math.random() - 0.5) * 240,
      color: colors[i % colors.length],
      delay: Math.random() * 0.14
    };
  }), [count]);
  if (reduceMotion) return null;
  return <div className="pointer-events-none absolute left-1/2 top-[28%] z-40" aria-hidden="true" data-id="element-691" data-mp="1v5pbu5od1mgl">
      {stars.map(star => <motion.span key={star.id} className="absolute" style={{
      color: star.color,
      marginLeft: -star.size / 2,
      marginTop: -star.size / 2
    }} initial={{
      x: 0,
      y: 0,
      scale: 0.3,
      opacity: 0,
      rotate: 0
    }} animate={{
      x: star.x,
      y: star.y,
      scale: [0.3, 1.1, 0.7],
      opacity: [0, 1, 0],
      rotate: star.rotate
    }} transition={{
      duration: 1,
      ease: [0.23, 1, 0.32, 1],
      delay: 0.18 + star.delay
    }} data-id="element-692" data-mp="2i5j4zod0ipin">
          <StarIcon width={star.size} height={star.size} fill="currentColor" strokeWidth={0} data-id="element-693" data-mp="30xbzxobn6kt0" />
        </motion.span>)}
    </div>;
}